import { LocalizationProvider, DatePicker, AdapterDayjs } from "./MyCustomFile"
import dayjs from 'dayjs';

export const MyDate = ({ name, label, onChange, value, error, disabled }) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} locale="en">
            <DatePicker name={name} label={label} disabled={disabled || false} value={value ? dayjs(value) : null} format="DD/MM/YYYY" onChange={onChange} sx={{ width: '100%', marginTop: 1 }} slotProps={{ textField: { size: 'small' } }} error={error} />
        </LocalizationProvider>
    );
}